<template>
    <b-modal
        v-model="shown"
        centered
        :title="title"
        lazy
    >
        <div>

            <div class="mb-2">
                Are you sure you want to delete this tab?
            </div>

            <b-form-checkbox
                v-model="deleteGroupsAndCosts"
                inline
            >
                Delete all groups and costs in this tab?
            </b-form-checkbox>

        </div>
        <div slot="modal-footer">
            <b-btn
                variant="default"
                class="mr-2"
                @click="close()"
            >
                Close
            </b-btn>
            <Button
                variant="danger"
                :loading="submitLoading"
                @click="handleSubmit()"
            >
                Confirm
            </Button>
        </div>
    </b-modal>
</template>

<script>
import vueComponentReset from '@ianwalter/vue-component-reset';

const resetMixin = vueComponentReset(() => ({
    shown: false,
    tabId: null,
    title: '',
    deleteGroupsAndCosts: false,
    submitLoading: false,
}));

export default {

    mixins: [
        resetMixin,
    ],

    created() {
        this.$eventBus.$on(this.$events.openDeleteTabModal, (tab) => {
            this.reset();
            this.tabId = tab.id;
            this.title = `Delete Tab - ${tab.name}`;
            this.open();
        });
    },

    methods: {
        async handleSubmit() {
            this.submitLoading = true;
            await this.$store.dispatch('costable/deleteTab', {
                tabId: this.tabId,
                deleteGroupsAndCosts: this.deleteGroupsAndCosts,
            });
            this.submitLoading = false;
            this.close();
        },
        open() {
            this.shown = true;
        },
        close() {
            this.shown = false;
        },
    },

};
</script>
